import { ITool } from "./interfaces/ITool";

export default class Tool implements ITool {
  public id: string = "";
  public name: string = "";

  // Constructor
  constructor(id: string = "", name: string = "") {
    this.id = id;
    this.name = name;
  }
}
